export default __webpack_public_path__ + "static/media/banner6.eb913dc6.png";